import React from "react"
import Cabecalho from "../Cabecalho"
import { PeriodoEntregaFornecedorComponent } from "./components/PeriodoEntregaFornecedorComponent"

export function PeriodoEntregaFornecedor() {
    return (
        <>
            <Cabecalho pagina="Horários de Delivery" />
            <PeriodoEntregaFornecedorComponent />
        </>
    )
}
